import { Component } from '@angular/core';

@Component({
  selector: 'app-base-layout',
  imports: [],
  templateUrl: './base-layout.component.html',
  styleUrl: './base-layout.component.scss'
})
export class BaseLayoutComponent {

}
